import { createFileRoute } from '@tanstack/react-router'

import { AnalyticsPowerSkillsTabPanel } from '@/analytics/components/AnalyticsPowerSkillsTabPanel/AnalyticsPowerSkillsTabPanel'
import { TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED } from '@/core/constants/constants'
import { track } from '@/core/utils/tracking/track'

export const Route = createFileRoute(
  '/company/_management/analytics/power-skills',
)({
  component: AnalyticsPowerSkillsTabPanel,
  onEnter: () => {
    track(TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED, {
      dashboard_page: 'power-skills',
    })
  },
})
